module.exports = __webpack_public_path__ + "img/IMG_8990.b62373e3.jpg";